import { render, staticRenderFns } from "./plates_count.vue?vue&type=template&id=71837bc6&scoped=true"
import script from "./plates_count.vue?vue&type=script&lang=js"
export * from "./plates_count.vue?vue&type=script&lang=js"
import style0 from "./plates_count.vue?vue&type=style&index=0&id=71837bc6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71837bc6",
  null
  
)

export default component.exports